module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/sp-cover-5-a3f33272f9b23138ee5b2b939f8dc0fa.webp";